/** OAuth scope used for Synergy client-credentials tokens (fixed; not configurable per integration). */
export const JACK_HENRY_SYNERGY_OAUTH_SCOPE =
  'http://jackhenry.com/auth/jha/jxapigateway'

export interface IJackHenrySynergyIntegrationConfig {
  /** Optional stored value used when the x-oe-oauth-client-id request header is omitted. */
  clientId?: string
  /** Optional stored value used when the x-oe-oauth-client-secret request header is omitted. */
  clientSecret?: string
  scope?: string
  /** Optional stored value used when the x-oe-institution-id request header is omitted. */
  institutionId?: string
  /** Optional stored value used when the x-oe-institution-environment request header is omitted. */
  institutionEnvironment?: string
}
